import { isDecodedFormat, isEncodedFormat } from "../models/shared/Format";
import { decodeColorFormat, decodeCurrencyFormat, decodeDateFormat, decodeFontFormat, decodeNumberFormat, decodeTextFormat, encodeColorFormat, encodeCurrencyFormat, encodeDateFormat, encodeFontFormat, encodeNumberFormat, encodeTextFormat, getFormatLookups, encodeFormat } from "./formats";
export const toDecodedFormat = format => {
  if (isDecodedFormat(format)) {
    return format;
  }
  const formatLookup = getFormatLookups(format);
  return {
    ...decodeColorFormat(formatLookup),
    ...decodeCurrencyFormat(formatLookup),
    ...decodeDateFormat(formatLookup),
    ...decodeFontFormat(formatLookup),
    ...decodeNumberFormat(formatLookup),
    ...decodeTextFormat(formatLookup)
  };
};
export const toEncodedFormat = format => {
  if (isEncodedFormat(format)) {
    return format;
  }
  const encodedValues = {
    ...encodeColorFormat(format),
    ...encodeCurrencyFormat(format),
    ...encodeFontFormat(format),
    ...encodeNumberFormat(format),
    ...encodeTextFormat(format),
    ...encodeDateFormat(format)
  };
  return encodeFormat(encodedValues);
};
//# sourceMappingURL=Format.js.map